
import {Component, Vue} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import {EicraproDurumu, eicraproBekleniyorHatasiMi} from "@/utils/eicraproBaglantisi";
import {BotBeklemeSebebi, botBeklemeGorunurMu} from "@/utils/botBekleme";
import {PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {uyapEngelHatasiMi} from "@/plugins/uyap-plugin/UyapEngeli";

@Component
export default class UyapConnectionInfo extends Vue {
  @Getter isUyapConnected!: boolean;
  @Getter isDevMode!: boolean;
  @Action connectToUyap!: (payload?: { kullanici?: boolean }) => Promise<void>;
  @Getter eicraproDurumu!: EicraproDurumu;
  @Getter eicraproDurumMesaji!: string;
  @Getter botBeklemeSebebi!: BotBeklemeSebebi | null;
  @Getter getPlayerDurum!: PlayerDurum;

  get iconColor(): string {
    return this.isUyapConnected ? 'green' : 'white';
  }

  get tooltipText(): string {
    if (this.isUyapConnected) return 'UYAP Bağlantısını yenile.';
    // 'tckn-eksik': lisans doğrulaması kimliği reddetti (TCKN eksik / lisans yok); 'yok': eİcraPro bekleniyor.
    if (this.eicraproDurumu !== 'tamam') {
      return this.eicraproDurumu === 'tckn-eksik' ? this.eicraproDurumMesaji : 'eİcraPro bağlantısı bekleniyor';
    }
    // Durdur'a basılmış bot beklemiyor: bekleme metni yalnız bot çalışırken ('oto') gösterilir.
    return botBeklemeGorunurMu(this.botBeklemeSebebi, this.getPlayerDurum) ? "Bot bekliyor: Uyap'a Bağlan" : "Uyap'a Bağlan";
  }

  handleAction(): void {
    if (this.isUyapConnected) {
      this.openUyap();
    } else {
      // Hata durumu store'da uyapStatusMessage olarak gösteriliyor;
      // burada sadece unhandled rejection engellenir.
      // Kullanıcının kendi eylemi: UYAP engeli kilidi açıkken yalnız bu işaretli çağrı geçer.
      this.connectToUyap({kullanici: true}).catch((e: unknown) => {
        // UYAP engeli: nedeni uyarı penceresi ve durum kartı söyler (toast yok).
        if (uyapEngelHatasiMi(e)) {
          return;
        }
        if (eicraproBekleniyorHatasiMi(e)) {
          this.$toast.info((e as Error).message);
          return;
        }
        console.error('UYAP bağlantısı başarısız.', e);
      });
    }
  }

  openUyap(): void {
    this.$store.dispatch('openUyapWindow');
  }
}
